<template>
  <div style="height: 100vh; width: 100vw">
    <div class="r-logo">
      <h2>欢迎登录</h2>
    </div>
    <div class="logo-box">
      <h1 class="clearfiex">账号登录</h1>
      <ul>
        <li class="phone">
          <span><img src="@/assets/l-name.png"></span>
          <input v-model="username" maxLength="20" name="" type="text" placeholder="请输入账号"></li>
        <li class="code">
          <span><img src="@/assets/l-pass.png"></span>
          <input v-model="password" maxLength="20" type="password" name="" placeholder="请输入密码">
        </li>
        <li class="code-img">
          <div class="code">
            <span><img src="@/assets/l-pass.png"></span>
            <input v-model="code" maxLength="10" name="" type="text" placeholder="请输入验证码">
          </div>
          <span style="margin-left: 5px; width: 110px; height: 44px; display: inline-block;">
            <img :src="codeImage" style="width: 100%;height: 100%" @click="changCode">
          </span>
        </li>
      </ul>
      <input class="logo-but" @click="submit" name="" type="button" value="登录">
    </div>
    <div v-if="visibleInfo" class="zc"><i>本服务由苏州芯爱信息科技有限公司支持</i><i>服务电话：15995256355</i></div>
    <div  class="zc" @click="handleBeiAn">
      <i >苏ICP备2023019203号-2</i>
    </div>
    <div class="zc">
    <i> <img width="18" height="20" src="@/assets/beian.png"/>苏公网安备32050602013649号</i>
    </div>
    <div>
      <a-drawer
          class="totop"
          title="免责申明"
          :placement="placement"
          :closable="true"
          :visible="visible"
          @close="onClose"
          height="300"
      >
        <p style="margin-bottom: 5px">该服务由第三方提供，相关的服务与责任由第三方承担，如有疑问请拨打第三方客服服务电话。</p>
        <p style="margin-bottom: 0">客服电话：15995256355</p>
        <p style="margin-bottom: 0; font-size: 14px">(周一至周五8:30-17:00)</p>
        <div class="close-tip">
          <!--          <a-checkbox @change="onChange">-->
          <!--            不再提示-->
          <!--          </a-checkbox>-->
          <div style="display: flex; justify-content: center; align-items: center;margin-top: 15px">
            <a-button type="primary" @click="onClose">
              确认
            </a-button>
          </div>
        </div>
      </a-drawer>
    </div>

  </div>
</template>


<script>
  import Utils from '../../js/common/utils';
  import {Toast} from 'mint-ui';
  import { validationCodeWithImage } from '@/api/login'
  import {isOpenBank} from "../../utils/common";
  export default {
    name: "Login",
    data() {
      return {
        visibleInfo: false,
        visible: false,
        placement: 'bottom',
        username: '',
        password: '',
        code: '',
        codeKey: '',
        codeImage: undefined,
        flag: true
      }
    },
    created() {
      if (Utils.getLocal("Authorization")) {
        this.$router.replace({name: '/'})
      }
      this.changCode()
      this.device()
    },
    methods: {
      handleBeiAn () {
        window.open('https://beian.miit.gov.cn/#/Integrated/index')
      },
      device () {
        const isTure = isOpenBank()
        this.visible = isTure
        this.visibleInfo =  isTure
      },
      onClose () {
        this.visible = false
      },
      // 获取图形验证码
      changCode () {
        validationCodeWithImage().then((res) => {
          if (res.code === 10000) {
            this.codeKey = res.result.codeKey
            this.codeImage = res.result.code
          }
        })
      },
      submit() {
        if (!this.username) {
          Toast({message: '请输入账号', duration: 1000})
          return
        }
        if (!this.password) {
          Toast({message: '请输入密码', duration: 1000})
          return
        }
        if (!this.code) {
          Toast({ message: '请输入验证码', duration: 1000 })
          return
        }

        if (this.flag) {
          this.flag = false
          R.Login.login({
            username: this.username,
            password: this.password,
            code: this.code,
            codeKey: this.codeKey
          }).then(res => {
            this.flag = true
            Utils.saveLocal("Authorization", res)
            Utils.saveLocal("identity", {name: "家长", value: 1});
            this.$router.replace({path: '/'})
          }).catch(() => {
            this.changCode()
            this.flag = true
          })
        }


      }
    }
  }
</script>

<style scoped>
.zc{
  width: 100%;
  color: #0a0a0a;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.zc i{
  font-style: normal;
  padding-top: 20px;
  font-size: 14px;
}
.logo-but {
  display: flex;
  padding: 10px;
  background:#66C779;
  border-radius: 25px;
  width:100%;
  align-items: center;
  justify-content: center;
  height:52px;
  border: none;
  font-size:18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FFFFFF;
  margin-top:45px;
}
  .r-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("~@/assets/logo-bg.png") center center no-repeat;
    background-size: 100% 100%;
    height:234px;
    width: 100%;
  }
.r-logo h2{
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  letter-spacing: 2px;
}

  .logo-box {
    display: flex;
    padding: 0 32px;
    flex-direction: column;
    height: 60vh;
    /*justify-content: center;*/
  }
  .logo-box h1{
    display: flex;
    position: relative;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #555555;
    flex-direction: column;
    margin-bottom: 45px;
  }
.logo-box h1:after{
  display: flex;
  width: 35px;
  height: 4px;
  background: #66C779;
  border-radius: 4px;
  margin-top: 6px;
}
  .logo-box h2 {
    display: block;
    font-size: 16px;
    font-weight: bold;
    color: #000000;
    padding: 38px 0;
  }

  .logo-box ul li {
    display: flex;
    align-items: center;
    height:46px;
    background: #FFFFFF;
    margin-bottom: 20px;
    padding: 0 14px;
  }
.logo-box ul li.code-img{
  padding:0;
}
  .logo-box ul li.phone{
    height: 46px;
    background: #F4F5F7;
    border-radius:100px;
  }
.logo-box ul .code{
  height: 46px;
  background: #F4F5F7;
  border-radius:100px;
  display: flex;
  align-items: center;
}
.logo-box ul li.code-img .code{
  padding: 0 14px;
}
  .logo-box ul li input {
    display: flex;
    flex: 1;
    align-items: center;
    color: #333333;
  }

  .logo-box ul li span {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 29px;
    width: 25px;
    margin-right:5px;
  }

  .logo-box ul li span img {
    width: 12px;
    height: 12px;
    position: relative;
  }

  .logo-box ul .code span img {
    width: 12px;
    height: 15px;
    position: relative;
  }
  .logo-box ul li.phone span img{
    width: 14px;
    height: 16px;
  }
  .logo-box ul li input {
    display: block;
    height: 44px;
    color: #333333;
    font-size: 14px
  }
.totop{
  display: flex;
  align-items: center;
  justify-content: center;
}
.ant-drawer-body p{
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  font-size: 16px;
  text-align: center;
  padding: 0 20px;
}
.close-tip button{
  font-size: 16px;
  width: 50%;
}
/deep/.ant-drawer-content-wrapper{
  box-shadow: inherit !important;
}
/deep/.ant-drawer-content-wrapper{
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/.ant-drawer-content{
  width:650px;
  border-radius: 12px 12px 0 0;
}
</style>
